import React, { createContext, useContext, useEffect, useState } from 'react';

const ConsultationContext = createContext();

export const useConsultation = () => useContext(ConsultationContext);

export const ConsultationProvider = ({ patientId, children }) => {
  const [consultations, setConsultations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConsultations = async () => {
      const res = await fetch(`/api/v1/consultations?patient_id=${patientId}`);
      const data = await res.json();
      const sorted = data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setConsultations(sorted);
      setLoading(false);
    };

    fetchConsultations();
  }, [patientId]);

  const value = { consultations, setConsultations, loading };

  return (
    <ConsultationContext.Provider value={value}>
      {children}
    </ConsultationContext.Provider>
  );
};
